'use client';
import type { ReactNode } from 'react';
import { useSearchParams as useNextSearchParams } from 'next/navigation';
import Link from 'next/link';
import type { NavigationAdapter } from '@insforge/react/navigation';

/**
 * Next.js navigation adapter
 * Uses Next.js's useSearchParams hook and Link component
 * Provides optimized navigation with prefetching and client-side routing
 */
export const NextNavigationAdapter: NavigationAdapter = {
  /**
   * Returns URLSearchParams from Next.js's useSearchParams
   * Reactive - updates when URL changes
   */
  useSearchParams() {
    const nextSearchParams = useNextSearchParams();
    // Convert Next.js's ReadonlyURLSearchParams to URLSearchParams
    return new URLSearchParams(nextSearchParams?.toString() || '');
  },

  /**
   * Next.js's Link component for optimized client-side navigation
   * Supports prefetching, scroll restoration, and shallow routing
   */
  Link({ href, className, children }: { href: string; className?: string; children: ReactNode }) {
    return (
      <Link href={href} className={className}>
        {children}
      </Link>
    );
  },
};
